import { PetType } from '@yawi/types';

export interface BreedOption {
  value: string;
  label: string;
}

export const DOG_BREEDS: BreedOption[] = [
  { value: 'labrador', label: 'Labrador Retriever' },
  { value: 'golden_retriever', label: 'Golden Retriever' },
  { value: 'german_shepherd', label: 'Pastor Alemán' },
  { value: 'bulldog', label: 'Bulldog' },
  { value: 'french_bulldog', label: 'Bulldog Francés' },
  { value: 'poodle', label: 'Poodle' },
  { value: 'beagle', label: 'Beagle' },
  { value: 'rottweiler', label: 'Rottweiler' },
  { value: 'yorkshire', label: 'Yorkshire Terrier' },
  { value: 'boxer', label: 'Boxer' },
  { value: 'dachshund', label: 'Dachshund (Salchicha)' },
  { value: 'siberian_husky', label: 'Husky Siberiano' },
  { value: 'doberman', label: 'Dóberman' },
  { value: 'shih_tzu', label: 'Shih Tzu' },
  { value: 'chihuahua', label: 'Chihuahua' },
  { value: 'pomeranian', label: 'Pomerania' },
  { value: 'maltese', label: 'Maltés' },
  { value: 'schnauzer', label: 'Schnauzer' },
  { value: 'cocker_spaniel', label: 'Cocker Spaniel' },
  { value: 'border_collie', label: 'Border Collie' },
  { value: 'pitbull', label: 'Pitbull' },
  { value: 'akita', label: 'Akita' },
  { value: 'pug', label: 'Pug' },
  { value: 'boston_terrier', label: 'Boston Terrier' },
  { value: 'jack_russell', label: 'Jack Russell Terrier' },
  { value: 'mixed', label: 'Mestizo' },
  { value: 'other', label: 'Otra' },
];

export const CAT_BREEDS: BreedOption[] = [
  { value: 'persian', label: 'Persa' },
  { value: 'siamese', label: 'Siamés' },
  { value: 'maine_coon', label: 'Maine Coon' },
  { value: 'bengal', label: 'Bengalí' },
  { value: 'ragdoll', label: 'Ragdoll' },
  { value: 'british_shorthair', label: 'British Shorthair' },
  { value: 'abyssinian', label: 'Abisinio' },
  { value: 'sphynx', label: 'Sphynx' },
  { value: 'scottish_fold', label: 'Scottish Fold' },
  { value: 'russian_blue', label: 'Azul Ruso' },
  { value: 'norwegian_forest', label: 'Bosque de Noruega' },
  { value: 'burmese', label: 'Burmés' },
  { value: 'birman', label: 'Birmano' },
  { value: 'exotic_shorthair', label: 'Exótico de Pelo Corto' },
  { value: 'american_shorthair', label: 'Americano de Pelo Corto' },
  { value: 'mixed', label: 'Mestizo' },
  { value: 'other', label: 'Otra' },
];

export const BIRD_BREEDS: BreedOption[] = [
  { value: 'canary', label: 'Canario' },
  { value: 'parakeet', label: 'Periquito' },
  { value: 'cockatiel', label: 'Cacatúa Ninfa' },
  { value: 'cockatoo', label: 'Cacatúa' },
  { value: 'parrot', label: 'Loro' },
  { value: 'macaw', label: 'Guacamaya' },
  { value: 'lovebird', label: 'Agapornis' },
  { value: 'finch', label: 'Pinzón' },
  { value: 'dove', label: 'Paloma' },
  { value: 'budgerigar', label: 'Periquito Australiano' },
  { value: 'african_grey', label: 'Loro Gris Africano' },
  { value: 'conure', label: 'Cotorra' },
  { value: 'other', label: 'Otra' },
];

export const OTHER_BREEDS: BreedOption[] = [
  { value: 'hamster', label: 'Hámster' },
  { value: 'guinea_pig', label: 'Cobayo/Cuy' },
  { value: 'rabbit', label: 'Conejo' },
  { value: 'turtle', label: 'Tortuga' },
  { value: 'fish', label: 'Pez' },
  { value: 'ferret', label: 'Hurón' },
  { value: 'hedgehog', label: 'Erizo' },
  { value: 'chinchilla', label: 'Chinchilla' },
  { value: 'snake', label: 'Serpiente' },
  { value: 'lizard', label: 'Lagartija/Iguana' },
  { value: 'other', label: 'Otro' },
];

export const BREEDS_BY_TYPE: Record<PetType, BreedOption[]> = {
  DOG: DOG_BREEDS,
  CAT: CAT_BREEDS,
  BIRD: BIRD_BREEDS,
  OTHER: OTHER_BREEDS,
};

export const getBreedsByType = (type: PetType): BreedOption[] => {
  return BREEDS_BY_TYPE[type] || [];
};

export const PET_TYPE_OPTIONS: BreedOption[] = [
  { value: 'DOG', label: 'Perro' },
  { value: 'CAT', label: 'Gato' },
  { value: 'BIRD', label: 'Ave' },
  { value: 'OTHER', label: 'Otro' },
];

export const getPetTypeLabel = (type: PetType): string => {
  const option = PET_TYPE_OPTIONS.find(opt => opt.value === type);
  return option?.label || type;
};
